var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.4 14.5L0 13.1l5.6-5.6L0 1.9 1.4.5 7 6.1 12.6.5 14 1.9 8.4 7.5l5.6 5.6-1.4 1.4L7 8.9l-5.6 5.6z",
    fill: "#707376"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAxNCAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEuNCAxNC41TDAgMTMuMUw1LjYgNy41TDAgMS45TDEuNCAwLjVMNyA2LjFMMTIuNiAwLjVMMTQgMS45TDguNCA3LjVMMTQgMTMuMUwxMi42IDE0LjVMNyA4LjlMMS40IDE0LjVaIiBmaWxsPSIjNzA3Mzc2Ii8+Cjwvc3ZnPgo=";
export { SvgCross as ReactComponent };